import { render, staticRenderFns } from "./CanceledEnvelopeFeedbackModal.vue?vue&type=template&id=266a1f95&lang=pug"
import script from "./CanceledEnvelopeFeedbackModal.vue?vue&type=script&lang=js"
export * from "./CanceledEnvelopeFeedbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports